import "./index.css";
import type { IBadgeProps, IBadgeSize } from "./types";
import { clsx } from "clsx";
import { Typography } from "../Typography";
import type { ITypographyVariant } from "../Typography/types";
import { useMediaQuery } from "../../hooks/useMediaQuery";

export const Badge = (props: IBadgeProps) => {
  const {
    ariaLabel,
    anchor,
    content,
    className,
    variant = "blue-light",
    hide = false,
  } = props;
  const isMobile = useMediaQuery("(max-width: 639px)");
  const size: IBadgeSize = props.size || (isMobile ? "md" : "sm");

  const rootClass = clsx(
    "nuco-badge__container",
    `nuco-badge__badge--${variant}`,
    `nuco-badge__badge--${size}`,
    className,
  );

  const textSizeMap: Record<IBadgeSize, ITypographyVariant> = {
    xs: "footnote",
    sm: "caption",
    md: "subtitle",
    lg: "subtitle",
  };

  return (
    <div className={rootClass}>
      {anchor}
      {!hide && (
        <div
          className="nuco-badge__badge"
          aria-live="polite"
          aria-label={ariaLabel || `Badge: ${content}`}
        >
          <Typography variant={textSizeMap[size]} text={content} />
        </div>
      )}
    </div>
  );
};
